export default {
    namespaced: true,
    state: {
        isClean: true,
        courseSchedules: [],
        bookings: [],
        selected: {
            courseSchedule: null,
            resetSession: null,
            guest: null,
            courseOrder: null,
            booking: null,
        },
    },
    mutations: {
        clear: (state, full) => {
            state.bookings = [];
            state.courseSchedules = [];
            state.selected.courseSchedule = null;
            state.selected.resetSession = null;
            state.selected.guest = null;
            state.selected.booking = null;
            state.selected.courseOrder = null;
            if (full) {
                state.query = '';
            }
            state.isClean = true;
        },
        query: (state, query) =>  {
            state.query = query;
        },
        course_schedules: (state, courseSchedules) =>  {
            state.courseSchedules = courseSchedules;
        },
        bookings: (state, bookings) =>  {
            state.bookings = bookings;
        },
        is_clean: (state, clean) =>  {
            state.isClean = clean;
        },
        select_booking: (state, booking) =>  {
            state.selected.booking = booking;
        },
        select_reset_session: (state, resetSession) =>  {
            state.selected.resetSession = resetSession;
        },
        select_course_order: (state, courseOrder) =>  {
            state.selected.courseOrder = courseOrder;
        },
        select_course_schedule: (state, courseSchedule) =>  {
            state.selected.courseSchedule = courseSchedule;
        },
        update_guest_in_booking: (state, payload) =>  {
            if (state.selected.booking) {
                let i = _.findIndex(state.selected.booking.guests, function (o) {
                    return o.id === payload.id;
                });
                state.selected.booking.guests[i] = payload;
            }
        },
        update_course_schedule: (state, payload) =>  {
            let i = _.findIndex(state.courseSchedules, function (c) {
                return c.id === payload.id;
            });
            state.courseSchedules[i] = payload;
            if (state.selected.courseSchedule && state.selected.courseSchedule.id === payload.id) {
                state.selected.courseSchedule = payload
            }

        },
    },
    getters: {
        selected: state => o => {
            return state.selected[o];
        },
        course_schedules: state => {
            return state.courseSchedules;
        }
    },
    actions: {
        async getResetSession({commit, state}, resetSessionId) {
            const url = _.replace(state.apiUrls.reset_session.show, 'RESET_SESSION_ID', resetSessionId);
            const call = api.get(url);
            call.then(response => {
                commit('select_reset_session', response.data);
            });
        },
        async getCourseSchedulesForResetSession ({commit, state}, resetSessionId) {
            const call = api.get('/admin/api/reset_session/' + resetSessionId + '/course_schedules');
            call.then(response => {
                this.guests = response.data;
            });
        },
    }
};
